// Quiet marginalia line acknowledging another same-browser Practice
// Surface is open. Ergonomic courtesy only — no modal, no block, no
// dismissal requirement. Per
// 2026-05-16-session-boundary-semantics-mini-spec.md §3.1.

import type { PathType } from '@/lib/concurrent-session'

const LABEL: Record<PathType, string> = {
    learn: 'Learn',
    review: 'Review',
    quiz: 'Quiz',
    challenge: 'Challenge',
}

export function ConcurrentSessionLine({ path }: { path: PathType }) {
    return (
        <p className="font-serif text-meta text-muted-fg italic">
            Another {LABEL[path]} session is open in this browser.
        </p>
    )
}
